import { REGISTRATION_ROUTES, RegistrationStepService } from '@fgb/core';
import { mergeRegistrationRoutes } from './registration.routes';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Route } from '@angular/router';

export interface RegistrationProviderConfig {
  routes: Route[];
}

export function provideRegistrationConfig(config?: Partial<RegistrationProviderConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([
    RegistrationStepService,
    {
      provide: REGISTRATION_ROUTES,
      useValue: mergeRegistrationRoutes(config?.routes),
    },
  ]);
}
